import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import { useSidebar } from '../../../helpers/sidebarClose';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import { TransactionRpt } from '../../../helpers/models/Models';
import { useEffect, useRef, useState } from 'react';
import MonthRptFormView from '../../../components/account/reports/monthly_rpt/MonthRptFormView';
import MonthRptListView from '../../../components/account/reports/monthly_rpt/MonthRptListView';
import PrintMonthyMasulView from '../../../components/account/reports/monthly_rpt/PrintMonthyMasulView';

const MonthlyReadingReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('mahasul_rtp');
    const [onMahasulReport, setOnMahasulReport] = useState<TransactionRpt[]>([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]);
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Monthly Mahasul Report' />} open={isOpen} onClose={closeSidebar}>
                <MonthRptFormView setOnMahasulReport={setOnMahasulReport} />
            </ReportDrawer>
            <MonthRptListView onMahasulReport={onMahasulReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintMonthyMasulView onMahasulReport={onMahasulReport} />
                </div>
            </div>
        </>
    );
}

export default MonthlyReadingReportCreateListView;
